<template>
  <main class="home">
    <HomeLanding />
    <ProjectsSection id="Projects" />
    <AboutSection id="About" />
  </main>
</template>

<script>
// @ is an alias to /src
import ProjectsSection from "@/components/ProjectsSection.vue";
import AboutSection from "@/components/AboutSection.vue";
import HomeLanding from "@/components/HomeLanding.vue";

export default {
  name: "home",
  components: {
    HomeLanding,
    ProjectsSection,
    AboutSection
  }
};
</script>
